/**
 * The default page sizes of the table pagination
 */
export const DefaultPageSizes = [
    10 as const,
    20 as const,
    50 as const,
    100 as const,
];


/**
 * The default pagination info of the application
 */
export const DefaultPaginationInfo = {
    pageSize: DefaultPageSizes[0],
    length: 0 as const,
    currentPage: 1 as const,
    sizes: DefaultPageSizes,
}

/**
 * The available download code formats
 */
export enum DownloadCodeFormat {
    qrCode = "QR Code",
}

/**
 * The worksheet constraints that can be applied to a worksheet
 */
export enum WorksheetConstraintMode {
    unconstrained = "Unconstrained",
    code = "Code",
    location = "Location",
    codeOrLocation = "CodeOrLocation",
}

/**
 * The types of the work session
 */
export enum WorkSessionType {
    Work = "Work",
    Break = "Break",
    Special = "Special",
}

/**
 * The status of the work session
 */
export enum WorkSessionStatus {
    Active = "Active",
    Inactive = "Inactive",
    Completed = "Completed",
}


/**
 * The types of the special work session limit unit
 */
export enum SpecialWorkSessionLimitUnit {
    Minute = "Minute",
    Hour = "Hour",
}

export enum EmployeeProfileStatus {
    active = "Active",
    inactive = "Inactive",
}